/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { TransactionStatus } from "./TransactionStatus";
import * as t from "io-ts";

// required attributes
const TransactionStatusResponseR = t.interface({});

// optional attributes
const TransactionStatusResponseO = t.partial({
  data: TransactionStatus
});

export const TransactionStatusResponse = t.intersection(
  [TransactionStatusResponseR, TransactionStatusResponseO],
  "TransactionStatusResponse"
);

export type TransactionStatusResponse = t.TypeOf<
  typeof TransactionStatusResponse
>;
